import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './calculator-angola-business-loan.component.scss';
import * as $ from 'jquery';
var CalculatorAngolaBusinessLoan = /** @class */ (function (_super) {
    tslib_1.__extends(CalculatorAngolaBusinessLoan, _super);
    function CalculatorAngolaBusinessLoan(element) {
        return _super.call(this, element) || this;
    }
    CalculatorAngolaBusinessLoan.prototype.init = function () {
        this.currencyForm = Array.from(this.element.querySelectorAll('.calculator-form__title--currency'));
        this.currencyCalculator = Array.from(this.element.querySelectorAll('.calculator-item__title--currency'));
        this.currencyTotal = Array.from(this.element.querySelectorAll('.js-total-currency'));
        this.inputLoanAmount = this.element.querySelector('input[name=loan_amount]');
        this.inputTerm = this.element.querySelector('input[name=term]');
        this.inputStartDate = this.element.querySelector('input[name=start_date]');
        this.inputInterest = this.element.querySelector('input[name=interest_rate]');
        this.totalMonthly = this.element.querySelector('.js-monthly');
        this.totalInterestRate = this.element.querySelector('.js-interest-rate');
        this.totalEndDate = this.element.querySelector('.js-end-date');
        this.buttonCalculate = this.element.querySelector('.js-calculator-calculate');
        this.buttonTermsAndCondtions = this.element.querySelector('.js-tcs-button');
        this.buttonApply = this.element.querySelector('.js-apply-button');
        this.buttonReset = this.element.querySelector('.js-calculator-reset');
        this.containerTermsAndConditions = this.element.querySelector('.calculator-angola-business-loan__result--terms');
        if (this.element.getAttribute('data-cta-modal-id')) {
            this.dataCtaModal = this.element.getAttribute('data-cta-modal-id');
            if (this.element.getAttribute('data-cta-text')) {
                this.dataCtaButtonText = this.element.getAttribute('data-cta-text');
                this.buttonApply.innerHTML = this.dataCtaButtonText;
            }
            else {
                this.buttonApply.innerHTML = 'Apply Now';
            }
            this.buttonApply.classList.add('js-apply-now-modal-open');
            this.buttonApply.setAttribute('data-modal', this.dataCtaModal);
            this.buttonApply.classList.remove('d-none');
        }
        else {
            if (this.element.getAttribute('data-cta-link')) {
                this.dataCtaLink = this.element.getAttribute('data-cta-link');
                if (this.element.getAttribute('data-cta-text')) {
                    this.dataCtaButtonText = this.element.getAttribute('data-cta-text');
                    this.buttonApply.innerHTML = this.dataCtaButtonText;
                }
                else {
                    this.buttonApply.innerHTML = 'Apply Now';
                }
                this.buttonApply.setAttribute('href', this.dataCtaLink);
                this.buttonApply.classList.remove('d-none');
            }
        }
        if (this.element.getAttribute('data-terms-link')) {
            this.dataTermsLink = this.element.getAttribute('data-terms-link');
            if (this.element.getAttribute('data-terms-text')) {
                this.dataTermsButtonText = this.element.getAttribute('data-terms-text');
            }
            else {
                this.dataTermsButtonText = "Terms and conditions";
            }
            this.buttonTermsAndCondtions.setAttribute('href', this.dataTermsLink);
            this.buttonTermsAndCondtions.innerHTML = this.dataTermsButtonText;
            this.containerTermsAndConditions.classList.remove('d-none');
        }
        if (this.element.getAttribute('data-disclaimer')) {
            this.dataTermsDisclaimer = this.element.getAttribute('data-disclaimer');
        }
        $(document).ready(function () {
            // start dateppicker
            $('input.js-start-date').datepicker({
                format: "dd/mm/yyyy",
                todayHighlight: true,
                enableOnReadonly: true,
                autoclose: true
            });
            var dateNew = new Date();
            var dateYear = dateNew.getFullYear();
            var dateMonth = (dateNew.getMonth() + 1).toString().padStart(2, "0");
            var dateDay = dateNew.getDate().toString().padStart(2, "0");
            // let dateFormatted: any = dateYear+'/'+dateMonth+'/'+dateDay;
            var dateFormatted = dateDay + '/' + dateMonth + '/' + dateYear;
            $('input.js-start-date').datepicker('setDate', dateFormatted);
            $('input.js-start-date').datepicker('setStartDate', dateFormatted);
        });
        this.calculate();
        this.prePopulateDate();
    };
    CalculatorAngolaBusinessLoan.prototype.bindEvents = function () {
        var _this = this;
        this.buttonCalculate.addEventListener('click', function (evt) {
            _this.calculate();
        });
        this.buttonReset.addEventListener('click', function (evt) {
            setTimeout(function () {
                var dateNew = new Date();
                var dateYear = dateNew.getFullYear();
                var dateMonth = (dateNew.getMonth() + 1).toString().padStart(2, "0");
                var dateDay = dateNew.getDate().toString().padStart(2, "0");
                // let dateFormatted: any = dateYear+'/'+dateMonth+'/'+dateDay;
                var dateFormatted = dateDay + '/' + dateMonth + '/' + dateYear;
                $('input.js-start-date').datepicker('setDate', dateFormatted);
                $('input.js-start-date').datepicker('setStartDate', dateFormatted);
            }, 500);
        });
    };
    CalculatorAngolaBusinessLoan.prototype.prePopulateDate = function () {
        // new date
        var todaysDay = new Date();
        var todaysDate = new Date();
        var getMonth = todaysDate.getMonth();
        todaysDate.setMonth(getMonth + parseFloat(this.inputTerm.value), 1);
        var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        var valDate = todaysDay.getDate() + " " + monthNames[todaysDate.getMonth()] + " " + todaysDate.getFullYear();
        this.totalEndDate.innerHTML = valDate;
    };
    CalculatorAngolaBusinessLoan.prototype.calculate = function () {
        var loanAmount = parseFloat(this.inputLoanAmount.value);
        var term = parseFloat(this.inputTerm.value);
        var interestRate = parseFloat(this.inputInterest.value);
        var final = -this.PMT(interestRate / 1200, term, loanAmount, 0, 0);
        var finalString = this.formatter(this.round(final, 0));
        this.totalMonthly.innerHTML = finalString;
        this.totalInterestRate.innerHTML = this.inputInterest.value + "%";
        // new date
        var datePartString = this.inputStartDate.value;
        var dateParts = datePartString.split("/");
        var todaysDay = new Date(dateParts[2], dateParts[1] - 1, +dateParts[0]);
        var todaysDate = new Date(dateParts[2], dateParts[1] - 1, +dateParts[0]);
        var getMonth = todaysDate.getMonth();
        todaysDate.setMonth(getMonth + parseFloat(this.inputTerm.value), 1);
        var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        var valDate = todaysDay.getDate() + " " + monthNames[todaysDate.getMonth()] + " " + todaysDate.getFullYear();
        this.totalEndDate.innerHTML = valDate;
    };
    CalculatorAngolaBusinessLoan.prototype.round = function (expr, decplaces) {
        var decpoint, str;
        str = '' + Math.round(expr * Math.pow(10, decplaces));
        while (str.length <= decplaces) {
            str = '0' + str;
        }
        decpoint = str.length - decplaces;
        return parseFloat(str.substring(0, decpoint) + '.' + str.substring(decpoint, str.length));
    };
    CalculatorAngolaBusinessLoan.prototype.formatter = function (value) {
        return parseFloat(value).toFixed(0).replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
    };
    CalculatorAngolaBusinessLoan.prototype.PMT = function (rate, period, value, futurevalue, type) {
        if (rate === void 0) { rate = 0; }
        if (period === void 0) { period = 0; }
        if (value === void 0) { value = 0; }
        if (futurevalue === void 0) { futurevalue = 0; }
        if (type === void 0) { type = 0; }
        if (!futurevalue)
            futurevalue = 0;
        if (!type)
            type = 0;
        if (rate == 0)
            return -(value + futurevalue) / period;
        var pvif = Math.pow(1 + rate, period);
        var pmt = rate / (pvif - 1) * -(value * pvif + futurevalue);
        if (type == 1) {
            pmt /= (1 + rate);
        }
        ;
        return pmt;
    };
    return CalculatorAngolaBusinessLoan;
}(Base));
export { CalculatorAngolaBusinessLoan };



//////////////////
// WEBPACK FOOTER
// ./components-angola/calculator-angola-business-loan/calculator-angola-business-loan.component.ts
// module id = 629
// module chunks = 0